export default {

    title: "Laden...",

    responses: {
        "404": {
            title: "Er is een fout opgetreden",
            header: "Er is een fout opgetreden",
            message: "Geldig token niet gevonden. Uw token is mogelijk verlopen."
        },
        "200": {
            title: "Succes",
            header: "Succes",
            message: "Uw verzoek is succesvol verwerkt."
        },
        "200_tfalogin": {
            title: "Aanmeldingsverificatie",
            header: "@:views.tunnel.service.responses.200_tfalogin.title",
            message: "De login is geverifieerd."
        },
        "404_tfalogin": {
            title: "Aanmeldingsverificatie",
            header: "@:views.tunnel.service.responses.404_tfalogin.title",
            message: "Geldig token niet gevonden. Uw token is mogelijk verlopen."
        },
        "200_tfaaddress": {
            title: "Adresverificatie",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Bedankt voor het bevestigen van je adres. Je kunt dit adres nu gebruiken als verzendadres bij het plaatsen van je bestelling."
        },
        "404_tfaaddress": {
            title: "Adresverificatie",
            header: "@:views.tunnel.service.responses.404_tfaaddress.title",
            message: "Geldig token niet gevonden. Uw token is mogelijk verlopen."
        },
        "201_delivery": {
            title: "Bedankt",
            header: "Bedankt",
            message: "Dank u voor uw reactie."
        },
        "201_shipment_received": {
            title: "Bedankt",
            header: "Bedankt",
            message: "Dank u voor uw reactie."
        },
        "400": {
            title: "Ongeldig verzoek. Er is een fout opgetreden.",
            header: "@:views.tunnel.service.responses.400.title",
            message: "Ongeldig verzoek. Er is een fout opgetreden."
        }
    }
}